import branding from "../branding/branding"
import { getActiveLanguage } from "../globalStates/LanguageState";

import { getMyEmailFromLocalStorage, getMyIdFromLocalStorage, getMyTypeFromLocalStorage } from "../globalStates/LoggedInUser";

declare global {
    interface Window {
        dataLayer: any[] | undefined;
    }
}

function track(data: any) {
    if (branding.gtmScriptDataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }
    if ("true" === localStorage.getItem("virtualguide-gtm-debug")) {
        console.log("GTM track")
        console.log(data)
    }
}

let lastNavigation: string | undefined
export function trackNavigation(pageTitle: string) {
    if (!pageTitle)
        return
    const newNavigation = window.location.pathname + pageTitle
    if (newNavigation === lastNavigation)
        return
    lastNavigation = newNavigation
    trackPageMetaData()
    trackPagePath(pageTitle)
}

function trackPageMetaData() {
    track({
        event: "Page Meta",
        websiteType: 'DEP',
        exhibitionNumber: getFairNumber(),
        language: getActiveLanguage().toLocaleUpperCase(),
        trafficType: getInternExtern(),
        customerType: getCustomerType(),
        loggedIn: getLoggedInState(), //Login Status des Nutzers
        environment: 'HFX DEP'
    })
}




function trackPagePath(pageTitle: string) {
    let trackingParams = {
        event: "virtPagePath",
        pagePath: window.location.pathname,
        pageTitle: pageTitle
    }
    if (window.location.pathname.includes("/person/")) {
        trackingParams = {
            event: "virtPagePath",
            pagePath: "/person/",
            pageTitle: "Personenprofil"
        }
    }
    track(trackingParams)
}

function getLoggedInState(): "Eingeloggt" | "Ausgeloggt" {
    return getMyIdFromLocalStorage() ? "Eingeloggt" : "Ausgeloggt"
}

function getFairNumber(){
    return branding.gtmFairNumber
}

const internExternInfoMap: { [email in string]: boolean } = {}
function getInternExtern(): "intern" | "extern" | "" {
    const myEmail = getMyEmailFromLocalStorage()
    if (!myEmail)
        return ""
    let intern = false
    if (myEmail in internExternInfoMap)
        intern = internExternInfoMap[myEmail]
    else {
        for (const internEmail of branding.configuration.internEmailAdresses) {
            if (myEmail.match(internEmail)) {
                intern = true
                break
            }
        }
        internExternInfoMap[myEmail] = intern
    }

    return intern ? "intern" : "extern"
}

function getCustomerType(): "Aussteller" | "Besucher" | "Medienvertreter" | "Aussteller" | "Besucher" | "" {
    const myType = getMyTypeFromLocalStorage()
    if (!myType) {
        return ""
    }
    switch (myType) {
        case "speaker":
        case "staff":
            return "Aussteller"
        case "press":
            return "Medienvertreter"
        case "attendee":
        case "guest":
        case "none":
            return "Besucher"

        default:
            return ""
    }
}


export function trackLogInSuccess() {
    track({
        event: 'gaEvent',
        eventCategory: 'Login',
        eventAction: 'DEP',
        eventLabel: 'Erfolgreich',
        event_name: 'login_dep_erfolgreich',
        loggedIn: 'Eingeloggt'
    })
}

export function trackLogInFailure() {
    track({
        event: 'gaEvent',
        eventCategory: 'Login',
        eventAction: 'DEP',
        eventLabel: 'Fehlermeldung',
        event_name: 'login_dep_fehlermeldung',
        loggedIn: 'Ausgeloggt'
    })
}
